import { useState } from "react"
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap"

import { FeedbackPostType, ISupportRequest } from "@api/schema"
import Icon from "@components/common/Icon"
import SinglePostForm from "@components/feedback/SinglePostForm"
import { withDynamicNamespaces } from "@components/hoc/withDynamicNamespaces"
import { NamespaceShortcut, useDynamicTranslation } from "@services/i18n"
import { asUriFragment, iriAsHtmlId } from "@services/util"
import { MODULE_PARTNER_MARKET_AVAILABLE } from "config"

const usedNamespaces: NamespaceShortcut[] = ['partner-market']

interface IProps {
  /** should elements like buttons be accessible b keyboard? not, if the card is not at the front of a flipping element */
  accessibleByKeyboard?: boolean
  supportRequest: ISupportRequest
  showIcon?: boolean
}

/**
 * This component provides an Button that triggers the creation of a discussion/SupportOffer for a SupportRequest.
 */
const SupportOfferPostPopup: React.FC<IProps> = (props: IProps) => {
  const {
    accessibleByKeyboard = true,
    showIcon = true,
    supportRequest,
  } = props
  const t = useDynamicTranslation()

  const [modalOpen, setModalOpen] = useState(false)
  const toggleModal = () => setModalOpen(!modalOpen)

  return MODULE_PARTNER_MARKET_AVAILABLE && <>
    <Button
      onClick={(e: React.MouseEvent<HTMLElement>) => {
        setModalOpen(true)
        e.stopPropagation()
      }}
      className="primary-btn"
      // do not allow access by keyboard, if the component's elements should not be accessible:
      // needed for flipping elements
      tabIndex={accessibleByKeyboard ? 0 : -1}
    >
      {showIcon && <Icon name="partner" size={25} />}
      {t("partner-market", "supportOffer.create.title")}
    </Button>


    <Modal
      isOpen={modalOpen}
      toggle={toggleModal}
    >
      <ModalHeader>
        {t("partner-market", "supportOffer.modalTitle")}
      </ModalHeader>
      <hr className="popup__hr" />
      <ModalBody >
        <SinglePostForm
          relatedObject={supportRequest}
          onSuccessSubmit={() => {
            // @todo: hier braucht es noch eine Systemreaktion:
            // Wird der User weitergeleitet? Gibt es einen Dankestext?
            // was passiert onNONSuccess?
            setModalOpen(false)
          }}
          onCancel={() => setModalOpen(false)}
          presetFeedbackPostType={FeedbackPostType.Support}
          redirectBack={window.location.toString() + asUriFragment(iriAsHtmlId(supportRequest))}
        />
      </ModalBody>
    </Modal>
  </>
}


export default withDynamicNamespaces<IProps>(SupportOfferPostPopup, usedNamespaces)